import { ShoppingBasket } from "lucide-react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { useStore } from "../context/StoreContext";
import type { Product } from "../lib/types";
import { Button, MediaImage, Price, QuantitySelector } from "./ui";

export function ProductCard({ product }: { product: Product }) {
  const cart = useCart();
  const { activeBranchId } = useStore();
  const item = cart.items.find(
    (entry) => String(entry.product.id) === String(product.id),
  );
  const available =
    product.isAvailable && (product.isUnlimited || product.stock > 0);

  return (
    <article className="product-card">
      <Link
        to={`/produk/${product.slug}`}
        className="product-card__media"
        aria-label={`Lihat ${product.name}`}
      >
        <MediaImage mediaId={product.mediaId} alt={product.name} />
        {product.promoPrice !== undefined &&
          product.promoPrice < product.price && (
            <span className="promo-flag">Promo</span>
          )}
      </Link>
      <div className="product-card__body">
        <div className="product-card__meta">
          {product.categoryName ?? "Kebutuhan harian"}
        </div>
        <Link to={`/produk/${product.slug}`} className="product-card__name">
          {product.name}
        </Link>
        <div className="product-card__unit">per {product.unit}</div>
        {product.description?.trim() && (
          <p className="product-card__description">{product.description}</p>
        )}
        <Price price={product.price} promoPrice={product.promoPrice} />
        <div
          className={`stock-text ${!product.isUnlimited && product.stock <= 3 && available ? "stock-text--low" : ""}`}
        >
          {product.isUnlimited && available
            ? "Stok selalu tersedia"
            : !available
            ? product.stock > 0
              ? `Tidak dijual · Sisa stok: ${product.stock}`
              : "Habis · Sisa stok: 0"
            : `Sisa stok: ${product.stock}`}
        </div>
        {item ? (
          <QuantitySelector
            value={item.quantity}
            max={product.isUnlimited ? 99 : product.stock}
            onChange={(value) => cart.setQuantity(product.id, value)}
            label={product.name}
          />
        ) : (
          <Button
            className="product-card__button"
            disabled={!available || activeBranchId === undefined}
            onClick={() =>
              activeBranchId !== undefined &&
              cart.addItem(product, activeBranchId)
            }
            icon={<ShoppingBasket aria-hidden="true" size={18} />}
          >
            {available ? "Tambah" : "Habis"}
          </Button>
        )}
      </div>
    </article>
  );
}
